"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameLoginCCLoader = void 0;
const routesCC_1 = require("../routesCC");
const initializer_1 = require("../../initializer");
const contactCenter_1 = require("../../contactCenter");
const frameBaseLoaderCommon_1 = require("../frameBaseLoaderCommon");
const frameLoginCCLoader = async (params) => {
    if ((0, contactCenter_1.isAssistedLoginRoute)()) {
        await initializer_1.AssistedAuthenticator.login();
    }
    (0, frameBaseLoaderCommon_1.frameLoaderBaseCommon)(params, routesCC_1.Router, routesCC_1.Routes);
};
exports.frameLoginCCLoader = frameLoginCCLoader;
//# sourceMappingURL=index.js.map